/**
 * Short-text tab of the segment editor: the compact event list ("dream summary") for one segment.
 *
 * Extracted from `SegmentUI.tsx` so the segment editor can switch between the three text fields
 * without stacking all of them.
 */
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Row, TextArea} from "react-vcomponents";
import {SegmentTextTabProps, UpdateSegmentTextField} from "./@Shared.js";

export const SegmentTextTab_ShortText = observer_mgl((props: SegmentTextTabProps)=>{
	const {segment} = props;
	return (
		<Row>
			<TextArea style={{border: "1px solid black"}} autoSize={true} /*autoSize_minHeight={true}*/ value={segment.shortText} onChange={val=>{
				UpdateSegmentTextField(props, "shortText", val);
			}}/>
		</Row>
	);
});
